import { c as _c } from "react/compiler-runtime";
import { ActionIcon, Button, ButtonProps, CopyButton, Popover, TextInput } from '@mantine/core';
import { ReactNode } from 'react';
import { HiCheck, HiClipboard } from 'react-icons/hi';
import { MdOutlineContentCopy } from 'react-icons/md';
import { ThemeOverride } from 'shared/ui';
import { twMerge } from 'tailwind-merge';
import React from 'react';
export const CopyLink = t0 => {
  const $ = _c(15);
  const {
    url,
    hideUrl,
    children,
    className,
    buttonProps
  } = t0;
  let t1;
  if ($[0] !== className) {
    t1 = twMerge("flex gap-2 items-center overflow-hidden", className);
    $[0] = className;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  let t2;
  if ($[2] !== hideUrl || $[3] !== url) {
    t2 = !hideUrl && <a href={url} target="_new" className="min-w-0 truncate break-all whitespace-break-spaces flex-shrink">{url}</a>;
    $[2] = hideUrl;
    $[3] = url;
    $[4] = t2;
  } else {
    t2 = $[4];
  }
  let t3;
  if ($[5] !== buttonProps || $[6] !== children) {
    t3 = t4 => {
      const {
        copied,
        copy
      } = t4;
      return <div className="flex items-center"><Button onClick={copy} className="flex-grow-0 ml-auto" leftSection={copied ? <ThemeOverride override={{
          colorScheme: "dark"
        }}><Popover opened={true} withArrow={true} position="bottom" withinPortal={true}><Popover.Target><div><HiCheck /></div></Popover.Target><Popover.Dropdown><div className="">Copied</div></Popover.Dropdown></Popover></ThemeOverride> : <MdOutlineContentCopy />} {...buttonProps}>{children ?? "Copy"}</Button></div>;
    };
    $[5] = buttonProps;
    $[6] = children;
    $[7] = t3;
  } else {
    t3 = $[7];
  }
  let t4;
  if ($[8] !== t3 || $[9] !== url) {
    t4 = <CopyButton value={url}>{t3}</CopyButton>;
    $[8] = t3;
    $[9] = url;
    $[10] = t4;
  } else {
    t4 = $[10];
  }
  let t5;
  if ($[11] !== t1 || $[12] !== t2 || $[13] !== t4) {
    t5 = <div className={t1}>{t2}{t4}</div>;
    $[11] = t1;
    $[12] = t2;
    $[13] = t4;
    $[14] = t5;
  } else {
    t5 = $[14];
  }
  return t5;
};
export const CopyText = t0 => {
  const $ = _c(11);
  const {
    text,
    title: t1,
    message: t2,
    styles
  } = t0;
  t1 === undefined ? "Text copied" : t1;
  t2 === undefined ? "The text has been copied to your clipboard" : t2;
  const [copied, setCopied] = React.useState(false);
  let t3;
  if ($[0] !== text) {
    t3 = () => {
      navigator.clipboard.writeText(text);
      setCopied(true);
      setTimeout(() => setCopied(false), 2000);
    };
    $[0] = text;
    $[1] = t3;
  } else {
    t3 = $[1];
  }
  let t4;
  if ($[2] !== copied) {
    t4 = copied ? <ThemeOverride override={{
      colorScheme: "dark"
    }}><Popover opened={true} withArrow={true} position="bottom" withinPortal={true}><Popover.Target><div><HiCheck size={18} /></div></Popover.Target><Popover.Dropdown><div className="">Copied</div></Popover.Dropdown></Popover></ThemeOverride> : <HiClipboard size={18} />;
    $[2] = copied;
    $[3] = t4;
  } else {
    t4 = $[3];
  }
  let t5;
  if ($[4] !== t3 || $[5] !== t4) {
    t5 = <ActionIcon variant="subtle" color="blue" className="ml-2" onClick={t3}>{t4}</ActionIcon>;
    $[4] = t3;
    $[5] = t4;
    $[6] = t5;
  } else {
    t5 = $[6];
  }
  let t6;
  if ($[7] !== styles || $[8] !== t5 || $[9] !== text) {
    t6 = <TextInput className="flex-grow" value={text} readOnly={true} size="md" rightSection={t5} styles={styles} />;
    $[7] = styles;
    $[8] = t5;
    $[9] = text;
    $[10] = t6;
  } else {
    t6 = $[10];
  }
  return t6;
};